import Contacticon from '../contacticon/Contacticon';
import { useEffect, useState, useMemo } from 'react';

const Hero = () => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);

  const toRotate = useMemo(() => [
    "I'm Ali Hassan",
    "Agentic AI Developer",
    "Full Stack Developer",
    "OpenAI SDK Expert",
    "LangGraph Specialist",
    "AI Innovator",
  ], []);
  const typingSpeed = 120; // Slightly faster typing for smoother experience
  const deletingSpeed = 80; // Faster deleting for better flow
  const pauseTime = 1500; // Reduced pause for snappier transitions

  useEffect(() => {
    let timer;
    const handleTyping = () => {
      const currentIndex = loopNum % toRotate.length;
      const fullText = toRotate[currentIndex];

      if (!isDeleting && text.length === fullText.length) {
        timer = setTimeout(() => setIsDeleting(true), pauseTime);
        return;
      }

      if (isDeleting && text.length === 0) {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        return;
      }

      const newText = isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1);

      setText(newText);
      const speed = isDeleting ? deletingSpeed : typingSpeed;
      timer = setTimeout(handleTyping, speed);
    };

    timer = setTimeout(handleTyping, typingSpeed);

    return () => clearTimeout(timer); // Cleanup to prevent memory leaks
  }, [text, isDeleting, loopNum, toRotate]);

  return (
    <section id="home" className="min-h-screen flex items-center justify-center 
      bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] 
      sm:bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] 
      from-blue-950 via-gray-900 to-black 
      bg-fixed bg-no-repeat bg-cover overflow-hidden">
      <div className="text-center px-4 sm:px-6 lg:px-8 w-full max-w-5xl mx-auto">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-2 sm:mb-4 animate-fade-in">
          Hi, I'm Ali Hassan
        </h1>
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold 
          bg-gradient-to-r from-blue-500 via-cyan-400 to-teal-400 
          bg-[length:200%_auto] animate-gradient-x
          bg-clip-text text-transparent min-h-[2.5em]">
          {text}
          <span className="animate-blink">|</span>
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-gray-300 mt-4 max-w-2xl mx-auto animate-fade-in-up">
          I’m a Full-Stack Agentic AI Developer and MVP SaaS Builder
          who turns ideas into scalable products.
        </p>
        <div className="mt-6">
          <Contacticon />
        </div>
      </div>
    </section>
  );
};

export default Hero;